module.exports = __webpack_public_path__ + "static/media/space-food_042.e4f8d69d.jpg";